import RouteHelper from './route-helper';

const PAGE = 'rooms-app-view';
const VIEW = {
  ROOMS_BOARDS: 'historical2-roomboard-view',
  DATASET: 'historical2-dataset-view-rooms',
  BOOKINGS: 'historical2-dataset-view-bookings',
  SCHEDULES: 'historical2-schedules-view',
  SETTINGS: 'settings-view'
};

function getRoomsDatasetRouteParams() {
  return {
    page: PAGE,
    view: VIEW.DATASET,
    pageName: 'Workspaces',
    permission: 'viewDatasets',
    datasetViewId: 'rooms',
    shareNameDictionary: ['Workspaces'],
    usesUtilization: true,
    utilizationTabs: ['0']
  };
}

function getBookingsDatasetRouteParams() {
  return {
    page: PAGE,
    view: VIEW.BOOKINGS,
    pageName: 'Bookings',
    permission: 'viewDatasets',
    datasetViewId: 'bookings',
    shareNameDictionary: ['Bookings'],
    usesUtilization: false,
    utilizationTabs: ['0']
  };
}

function getRoomsDatasetRoutes() {
  return [
    // legacy routes
    { url: 'rooms/data', params: Object.assign({ level: 'view' }, getRoomsDatasetRouteParams()) },
    { url: 'rooms/data/tabid/{tabId}', params: Object.assign({ level: 'tab' }, getRoomsDatasetRouteParams()) },
    { url: 'rooms/data/link/{link}', params: Object.assign({ level: 'filter' }, getRoomsDatasetRouteParams()) },
    // Use regular expressions so that we can take '/' as part of the params
    { url: new RegExp('rooms\/data\/params\/' + RouteHelper.FILTER_PARAMS_REGEX), params: Object.assign({ level: 'filter', regexGroups: ['params'] }, getRoomsDatasetRouteParams()) },
    { url: new RegExp('rooms\/data\/tabid\/([\\d\\w]+)\/params\/' + RouteHelper.FILTER_PARAMS_REGEX), params: Object.assign({ level: 'filter', regexGroups: ['tabId', 'params'] }, getRoomsDatasetRouteParams()) },

    // new more descriptive name routes
    { url: 'rooms/workspaces', params: Object.assign({ level: 'view' }, getRoomsDatasetRouteParams()) },
    { url: 'rooms/workspaces/tabid/{tabId}', params: Object.assign({ level: 'tab' }, getRoomsDatasetRouteParams()) },
    { url: 'rooms/workspaces/link/{link}', params: Object.assign({ level: 'filter' }, getRoomsDatasetRouteParams()) },
    // Use regular expressions so that we can take '/' as part of the params
    { url: new RegExp('rooms\/workspaces\/params\/' + RouteHelper.FILTER_PARAMS_REGEX), params: Object.assign({ level: 'filter', regexGroups: ['params'] }, getRoomsDatasetRouteParams()) },
    { url: new RegExp('rooms\/workspaces\/tabid\/([\\d\\w]+)\/params\/' + RouteHelper.FILTER_PARAMS_REGEX), params: Object.assign({ level: 'filter', regexGroups: ['tabId', 'params'] }, getRoomsDatasetRouteParams()) },
    { url: 'rooms/workspaces/tabid/{tabId}/link/{link}', params: Object.assign({ level: 'filter' }, getRoomsDatasetRouteParams()) },

    { url: 'rooms/bookings', params: Object.assign({ level: 'view' }, getBookingsDatasetRouteParams()) },
    { url: 'rooms/bookings/tabid/{tabId}', params: Object.assign({ level: 'tab' }, getBookingsDatasetRouteParams()) },
    { url: 'rooms/bookings/link/{link}', params: Object.assign({ level: 'filter' }, getBookingsDatasetRouteParams()) },
    // Use regular expressions so that we can take '/' as part of the params
    { url: new RegExp('rooms\/bookings\/params\/' + RouteHelper.FILTER_PARAMS_REGEX), params: Object.assign({ level: 'filter', regexGroups: ['params'] }, getBookingsDatasetRouteParams()) },
    { url: new RegExp('rooms\/bookings\/tabid\/([\\d\\w]+)\/params\/' + RouteHelper.FILTER_PARAMS_REGEX), params: Object.assign({ level: 'filter', regexGroups: ['tabId', 'params'] }, getBookingsDatasetRouteParams()) },
    { url: 'rooms/bookings/tabid/{tabId}/link/{link}', params: Object.assign({ level: 'filter' }, getBookingsDatasetRouteParams()) },
    // -- SUMMARY VIEWS --
    getNewDatasetRoute('buildingUsage', 'Building Usage', 'summaryview.buildingUsageDetail'),
  ];
}

// route to new product wide vue dataset instead of old knockout one
function getNewDatasetRoute(datasetName, datasetTitle, datasetKey, hasDashboard) {
  return {
      url: 'rooms/dataset/' + datasetName,
      params: {
          appId: 'rooms',
          captureType: 'page',
          level: 'view',
          page: PAGE,
          datasetName: datasetKey,
          hasDateRangePicker: false,
          hasExtendedDateRangePicker: true,
          hasDashboard: hasDashboard,
          pageId: 'historical2-dataset-' + datasetKey,
          permission: 'viewDatasets',
          title: datasetTitle,
          view: 'historical2-dataset',
      }
  };
}


export default [
  { url: 'rooms/dashboard', params: { page: PAGE, view: VIEW.ROOMS_BOARDS, level: 'view' } },
  { url: 'rooms/dashboard/link/{link}', params: { page: PAGE, view: VIEW.ROOMS_BOARDS, level: 'filter' } },
  { url: 'rooms/dashboard/tabid/{tabId}', params: { page: PAGE, view: VIEW.ROOMS_BOARDS, level: 'tab' } },
  { url: 'rooms/dashboard/tabid/{tabId}/link/{link}', params: { page: PAGE, view: VIEW.ROOMS_BOARDS, level: 'filter' } },
  // -- SUMMARY VIEWS --
  getNewDatasetRoute('buildingSummary', 'Building Usage', 'summaryview.buildingUsageDetail', true),
  ...getRoomsDatasetRoutes(),
  { url: 'rooms/reports', params: { page: PAGE, permission: 'reportManager', view: VIEW.SCHEDULES, level: 'view', title: 'Reports' } },
  { url: 'rooms/settings', params: { page: PAGE, permission: 'settings-view', view: VIEW.SETTINGS, level: 'view', title: 'Settings' } },
  { url: 'rooms/settings/tabid/{tabId}', params: { page: PAGE, permission: 'settings-view', view: VIEW.SETTINGS, level: 'tab', title: 'Settings' } },
  { url: /rooms\/?.*/, params: { redirect: 'rooms/dashboard', page: PAGE, view: VIEW.ROOMS_BOARDS, level: 'view' } }
]
